import { NidessoQueryParams } from "../components/router/query-params";
import { IsTruthy, NotEquals } from "./helper-functions";

export type UpdateListQueryParamOperator = (
  paramId: NidessoQueryParams,
  searchParams: URLSearchParams,
) => URLSearchParams;

export const getList: (
  paramId: string,
  searchQueryParams: URLSearchParams,
) => string[] = (paramID, searchQueryParams) => {
  const param = searchQueryParams.get(paramID);
  return param?.split(",").filter(IsTruthy) ?? [];
};

export const add: (value: string) => UpdateListQueryParamOperator =
  (value) => (paramId, searchQueryParams) => {
    const param = (searchQueryParams.get(paramId) ?? "")
      .split(",")
      .filter(IsTruthy);
    param.push(value);
    searchQueryParams.set(paramId, param.join(","));
    return searchQueryParams;
  };

export const remove: (value: string) => UpdateListQueryParamOperator =
  (value) => (paramId, searchQueryParams) => {
    const param = (searchQueryParams.get(paramId) ?? "")
      .split(",")
      .filter(NotEquals(value));
    if (param.length) {
      searchQueryParams.set(paramId, param.join(","));
    } else {
      searchQueryParams.delete(paramId);
    }
    return searchQueryParams;
  };
